'use client';

import { useEffect } from 'react';
import { initEmailScheduler } from '@/utils/emailScheduler';

export default function EmailSchedulerProvider() {
  useEffect(() => {
    // Initialize email reminder scheduler on app startup
    if (typeof window !== 'undefined') {
      initEmailScheduler();
    }
  }, []);

  // This component doesn't render anything
  return null;
}